import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get } from 'lodash';

import OrganizerControlsComponent from '../../components/purchase-dashboard/organizer-controls';
import Purchase from '../../lib/purchase';
import {
  getCurrentPurchase,
  getCurrentUserMembership,
  getFailedMemberships,
  getShortMemberships,
} from '../../selectors/purchase-selector';
import {
  showAutoPilotModal,
  showInviteModal,
  showMakeChangesModal,
  showCoverDifferenceModal,
  showResolveIssuesModal,
  disableAutoPilot,
  showAlert,

  ALERT_DASHBOARD_AUTO_PILOT_DISABLED,
  AUTOPILOT_MODAL,
} from '../../actions/index';

class OrganizerControls extends Component {
  constructor(props) {
    super(props);

    this.showAutoPilotModal = this.props.showAutoPilotModal.bind(this);
    this.showMakeChangesModal = this.props.showMakeChangesModal.bind(this);
    this.onAutoPilotOff = this.onAutoPilotOff.bind(this);
    this.onMakePurchase = this.onMakePurchase.bind(this);
    this.onCoverDifference = this.onCoverDifference.bind(this);
  }

  onAutoPilotOff() {
    const { purchase, authentication } = this.props;

    this.props.actions.showAlert(ALERT_DASHBOARD_AUTO_PILOT_DISABLED);
    this.props.actions.disableAutoPilot(purchase.id, authentication);
  }

  onCoverDifference() {
    this.props.showCoverDifferenceModal();
  }

  onMakePurchase(event) {
    event.preventDefault();
    event.stopPropagation();

    const { slug } = this.props.purchase;
    window.location = `/purchases/${slug}/make-purchase`;
  }

  canMakePurchase() {
    const { purchase, tipped, disabled } = this.props;

    if (disabled) return false;
    if (!Purchase.isActive(purchase.status)) return false;
    if (this.hasExpired()) return false;
    if (this.props.hasMembersWithIssues) return false;

    return tipped;
  }

  canUseOrganizerControls() {
    const { userMembership } = this.props;
    return userMembership && userMembership.role === 'organizer';
  }

  hasExpired() {
    const { dueDeadline } = this.props;
    return Purchase.isDateExpired(dueDeadline);
  }

  render() {
    if (!this.canUseOrganizerControls()) return null;
    if (Purchase.isCanceled(this.props.purchase.status)) return null;

    return (
      <OrganizerControlsComponent
        purchase={this.props.purchase}
        autoPilotEnabled={this.props.autoPilotEnabled}
        canMakePurchase={this.canMakePurchase()}
        dueDeadline={this.props.dueDeadline}
        commitDeadline={this.props.commitDeadline}
        expired={this.hasExpired()}
        disable={this.props.disabled}
        minSlots={this.props.minSlots}
        onCoverDifference={this.onCoverDifference}
        onAutoPilotEdit={this.showAutoPilotModal}
        onAutoPilotOff={this.onAutoPilotOff}
        onAutoPilotOn={this.showAutoPilotModal}
        onMakeChanges={this.showMakeChangesModal}
        onMakePurchase={this.onMakePurchase}
        onInvite={this.props.showInviteModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const purchase = getCurrentPurchase(state);

  const failedMemberships = getFailedMemberships(state);
  const shortMemberships = getShortMemberships(state);

  return {
    autoPilotModalChanged: !!state.ui.modals[AUTOPILOT_MODAL],
    hasMembersWithIssues: [...failedMemberships, ...shortMemberships].length > 0,
    authentication: state.session.authentication,
    purchase,
    autoPilotEnabled: get(purchase, 'autoPilotEnabled', false),
    userMembership: getCurrentUserMembership(state),
    dueDeadline: purchase.nextPaymentDueDeadline,
    commitDeadline: purchase.group.commitDeadline,
    minSlots: get(purchase, 'productOrGroupMinSlots', 2),
    tipped: purchase.tipped,
    disabled: Purchase.isWaitingForMerchantToComplete(purchase),
  };
};

const mapDispatchToProps = (dispatch) => {
  const containerActions = {
    disableAutoPilot,
    showAlert,
  };

  const componentActions = {
    showAutoPilotModal,
    showInviteModal,
    showMakeChangesModal,
    showResolveIssuesModal,
    showCoverDifferenceModal,
  };

  return {
    actions: bindActionCreators(containerActions, dispatch),
    ...bindActionCreators(componentActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizerControls);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/organizer-controls.container.js